import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SearchInput from 'src/components/SearchInput/SearchInput'

interface ProductSearchBarProps {
  searchText: string
  onSearchTextChange: (text: string) => void
}

const ProductSearchBar: React.FC<ProductSearchBarProps> = ({ searchText, onSearchTextChange }) => {
  const { t } = useTranslation()
  return (
    <Box marginBottom={4}>
      <SearchInput
        value={searchText}
        onChange={onSearchTextChange}
        placeholder={t('products.searchPlaceholder')}
      />
    </Box>
  )
}

export default ProductSearchBar
